import { datos } from '../data/contenido';

export default function Datos() {
  return (
    <section className="datos">
      <div className="envoltura">
        <div className="cabecera" data-reveal="">
          <p className="rotulo">Cómo funciona</p>
          <h2 className="titulo">Lo práctico</h2>
        </div>

        <dl className="datos__lista">
          {datos.map((dato, i) => (
            <div className="dato" key={dato.clave} data-reveal="" style={{ '--retraso': `${i * 70}ms` }}>
              <dt>{dato.clave}</dt>
              <dd>{dato.valor}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
